export default [
  { value: null, text: "Unknown" },
  { value: "0", text: "No schedule assigned" },
  { value: "1", text: "Schedule I" },
  { value: "2", text: "Schedule II" },
  { value: "3", text: "Schedule III" },
  { value: "4", text: "Schedule IV" },
  { value: "5", text: "Schedule V" },
  { value: "6", text: "Multiple schedules" },
  { value: "9", text: "No value" }
];
